// App-icon badge helper (Badging API). No-op where unsupported.

export function updateAppBadge(count) {
  if (!('setAppBadge' in navigator)) return;
  try {
    if (count > 0) navigator.setAppBadge(count);
    else navigator.clearAppBadge();
  } catch (e) {}
}
